import { render } from "./Notes16.vue?vue&type=template&id=61533f1b&scoped=true"
import script from "./Notes16.vue?vue&type=script&lang=js"
export * from "./Notes16.vue?vue&type=script&lang=js"

import "./Notes16.vue?vue&type=style&index=0&id=61533f1b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61533f1b"]])

export default __exports__